// `Symbol.asyncIterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.asynciterator
require('../internals/define-well-known-symbol')('asyncIterator');
